import { CoreApiVersionPath, RosaCoreApiService } from '@/rosa';
import { isNullish } from '@/utils/typing/is-nullish.predicate';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { CoreProjectCreationRequestBody, Project, ProjectRequestParams } from '../../interfaces/Project.interface';

@Injectable({
    providedIn: 'root'
})
export class AdvizeoCoreProjectsProvider {
    private _rosaCoreApiService = inject(RosaCoreApiService);

    fetchUserProjects$(): Observable<Project[]> {
        const projectMapper = (project: Project): Project => {
            return {
                ...project,
                allowedDashboardCount: isNullish(project.allowedDashboardCount)
                    ? 1
                    : project.allowedDashboardCount >= 0
                      ? project.allowedDashboardCount
                      : Infinity
            };
        };
        return this._rosaCoreApiService
            .get<Project[]>(`${CoreApiVersionPath.V3}me/projects`)
            .pipe(map(projects => projects.map(project => projectMapper(project))));
    }

    createProject$(body: CoreProjectCreationRequestBody): Observable<string> {
        return this._rosaCoreApiService.post(`${CoreApiVersionPath.V3}projects`, body);
    }

    updateProject$(projectId: string, project: Partial<ProjectRequestParams>): Observable<void> {
        return this._rosaCoreApiService.patch(`${CoreApiVersionPath.V3}projects/${projectId}`, project);
    }
}
